let datesSetForId: number | null = null;

export const setDatesSet = (prId: number, value: boolean) => {
  if (value) {
    datesSetForId = prId;
  } else if (datesSetForId === prId) {
    datesSetForId = null;
  }
};

export const getDatesSet = (prId: number) => {
  return datesSetForId === prId;
};

export const resetDatesSet = () => {
  datesSetForId = null;
};
